<template>

    <div class="container">

        <app-head title="Contact" />

        <div class="my-4">
            <h1>{{ __('Kontaktieren Sie uns') }}</h1>
        </div>

        <div class="row gx-5">

            <div class="col-md-6">
                <form @submit.prevent="submit">
                    <text-input :floating="true" label="Name" v-model="form.name" :error="form.errors.name" />
                    <div class="row row-cols-1 row-cols-md-2">
                        <div class="col">
                            <text-input :floating="true" label="email" v-model="form.email" type="email" :error="form.errors.email" />
                        </div>
                        <div class="col">
                            <text-input :floating="true" label="phone" v-model="form.phone" type="tel" :error="form.errors.phone" />
                        </div>
                    </div>
                    <text-input :floating="true" label="subject" v-model="form.subject" :error="form.errors.subject" />
                    <textarea-input :floating="true" class-name="size-large" label="message" v-model="form.message" :error="form.errors.message" />
                    <submit-button :form="form" />
                </form>
            </div>

            <div class="col-md-6">
                <p class="lead">
                    {{ __('Haben Sie Fragen oder Anmerkungen? Kontaktieren Sie uns. Unser Team steht Ihnen gerne Rede und Antwort.') }}
                </p>
                <hr />
                <div class="fs-4">
                    <div class="">
                        <i class="bi bi-telephone"></i>
                        {{ contactData.phone }}
                    </div>
                    <div class="">
                        <i class="bi bi-envelope"></i> 
                        <a :href="'mailto:' + contactData.email">{{ contactData.email }}</a>
                    </div>
                    <div class="">
                        <i class="bi bi-globe"></i> 
                        <a :href="contactData.url" target="_blank">{{ contactData.url }}</a>
                    </div>
                </div>
                <hr />
                <address class="fs-4" v-html="contactData.address">
                </address>
            </div>

        </div>

    </div>

</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'contactData',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: null,
                    email: null,
                    phone: null,
                    subject: null,
                    message: null,
                }),
            }
        },
        components: {
            TextInput,
            TextareaInput,
            SubmitButton,
        },
        methods: {
            submit() {
                this.form.post(route('contact.submit'), {
                    onSuccess: () => this.form.reset(),
                })
            }
        },
    }
</script>